<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-no" id="pt-1"><a id="page_5"><strong>The Letter <br/>of <br/>JUDE</strong> </a><a id="page_6"></a></h1><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010_Part01.vue?1f17ef55